/*
 * Circular Countdown v2.2.3
 *
 * Copyright 2013-2017, LambertGroup
 * 
 */

(function($) {
	
	function calculateRemainingTime(current_obj,options) {
		current_obj.remainingDays=Math.floor(current_obj.totalRemainingSeconds/current_obj.secondsInADay);
		current_obj.remainingHours=Math.floor((current_obj.totalRemainingSeconds-current_obj.remainingDays*current_obj.secondsInADay)/current_obj.secondsInAnHour);
		current_obj.remainingMinutes=Math.floor((current_obj.totalRemainingSeconds-current_obj.remainingDays*current_obj.secondsInADay-current_obj.remainingHours*current_obj.secondsInAnHour)/current_obj.secondsInAMinute);
		current_obj.remainingSeconds=current_obj.totalRemainingSeconds-current_obj.remainingDays*current_obj.secondsInADay-current_obj.remainingHours*current_obj.secondsInAnHour-current_obj.remainingMinutes*current_obj.secondsInAMinute;			

	}

		
	//circ
	function the_arc(type,the_ctx,the_canvas,behindCircleAlpha,behindCircleColor,circleAlpha,circleColor,current_obj,options,daysDiv,hoursDiv,minutesDiv,secondsDiv,ver_ie,doCentering) {
		if (current_obj.totalRemainingSeconds>=0) {
						var dsgx=0;
						switch(type)
						{
							case 'seconds':
							  degx=(60-current_obj.remainingSeconds)*2*Math.PI/60-0.5*Math.PI;
							  if (current_obj.remainingSeconds < 10) { current_obj.remainingSeconds = "0" + current_obj.remainingSeconds;};  // CUSTOM CODE - TANNER
							  current_obj.secondsNumberDiv.html(current_obj.remainingSeconds);
							  break;
							case 'minutes':
							   degx=(60-current_obj.remainingMinutes)*2*Math.PI/60-0.5*Math.PI;
                               if (current_obj.remainingMinutes < 10) { 
                                 var length = current_obj.remainingMinutes.length;
                                 if (length != 2 ) {
                                 	current_obj.remainingMinutes = "0" + current_obj.remainingMinutes;
                                 }
                               };
							   current_obj.minutesNumberDiv.html(current_obj.remainingMinutes);
							  break;
							case 'hours':
							   degx=(24-current_obj.remainingHours)*2*Math.PI/24-0.5*Math.PI;
							   if (current_obj.remainingHours < 10) { 
                                 var length = current_obj.remainingHours.length;
                                 if (length != 2 ) {
                                 	current_obj.remainingHours = "0" + current_obj.remainingHours;
                                 }
                               };
							   current_obj.hoursNumberDiv.html(current_obj.remainingHours);
							  break;
							case 'days':
							   degx=(current_obj.entireWorkingDaysPeriod-current_obj.remainingDays)*2*Math.PI/current_obj.entireWorkingDaysPeriod-0.5*Math.PI;
                               if (current_obj.remainingDays < 10) { 
                                 var length = current_obj.remainingDays.length;
                                 if (length != 2 ) {
                                 	current_obj.remainingDays = "0" + current_obj.remainingDays;
                                 }
                               };
                               current_obj.daysNumberDiv.html(current_obj.remainingDays);
							  break; 
							default:
							   degx=(60-current_obj.remainingSeconds)*2*Math.PI/60-0.5*Math.PI;
						}
						
						if (type=='days' && doCentering/* && current_obj.repetitionNo<=2*/) {
							//current_obj.repetitionNo++;
							centerNumbers(options,current_obj,daysDiv,hoursDiv,minutesDiv,secondsDiv);
						}
						if (ver_ie!=-1 && ver_ie<9) {
							//nothing	
						} else {
		
							the_ctx.clearRect(0,0,the_canvas.width,the_canvas.height);
							
							the_ctx.beginPath();
							the_ctx.globalAlpha=behindCircleAlpha/100;
							the_ctx.arc(parseInt((options.circleRadius+(options.circleLineWidth+options.behindCircleLineWidthExpand)/2+options.circleLeftRightPadding)*current_obj.pluginRatio,10), parseInt((options.circleRadius+(options.circleLineWidth+options.behindCircleLineWidthExpand)/2+options.circleTopBottomPadding)*current_obj.pluginRatio,10), parseInt(options.circleRadius*current_obj.pluginRatio,10), 0, 2 * Math.PI, false);
							the_ctx.lineWidth = parseInt((options.circleLineWidth+options.behindCircleLineWidthExpand)*current_obj.pluginRatio,10);
							the_ctx.strokeStyle = behindCircleColor;
							the_ctx.stroke();
							the_ctx.closePath();
							
			
							the_ctx.beginPath();
							the_ctx.globalAlpha=circleAlpha/100;
							the_ctx.arc(parseInt((options.circleRadius+(options.circleLineWidth+options.behindCircleLineWidthExpand)/2+options.circleLeftRightPadding)*current_obj.pluginRatio,10), parseInt((options.circleRadius+(options.circleLineWidth+options.behindCircleLineWidthExpand)/2+options.circleTopBottomPadding)*current_obj.pluginRatio,10), options.circleRadius*current_obj.pluginRatio, -0.5*Math.PI, degx ,  false);
							the_ctx.lineWidth = parseInt(options.circleLineWidth*current_obj.pluginRatio,10);
							the_ctx.strokeStyle = circleColor;
							the_ctx.stroke();
							the_ctx.closePath();
						}
						
						if (type=='seconds') {
							current_obj.remainingSeconds--;
						}
						
						if (current_obj.remainingSeconds<0) {
							//$('#logx').html(current_obj.remainingSeconds+' --  '+oldDate+'  -   '+current_obj.nowD);
							calculateRemainingTime(current_obj,options);
						}
		} else { //countdown complete
			if (type=='seconds' && current_obj.repetitionNo<=0) {
				if ( $.isFunction( options.complete ) ) {
					current_obj.repetitionNo++;
					clearInterval(current_obj.intervalIDSeconds);
					options.complete.call( this );
				} else { //auto-reset 24h
					if (options.autoReset24h) {
							resetNo=0;
							//alert ("a: "+options.launchingDate);
							current_obj.totalRemainingSeconds=-1;
							current_obj.new_nowD=new Date();
							theIntervalNowDate=Date.UTC(current_obj.new_nowD.getFullYear(), current_obj.new_nowD.getMonth(), current_obj.new_nowD.getDate(),  current_obj.new_nowD.getHours(), current_obj.new_nowD.getMinutes(), current_obj.new_nowD.getSeconds())/1000-Date.UTC(current_obj.nowD.getFullYear(), current_obj.nowD.getMonth(), current_obj.nowD.getDate(),  current_obj.nowD.getHours(), current_obj.nowD.getMinutes(), current_obj.nowD.getSeconds())/1000;
							
							while (current_obj.totalRemainingSeconds<0) {
									resetNo++;
									options.beginDate=options.launchingDate;
									/*var old_launchingDate_arr=options.launchingDate.split(',');
									options.launchingDate=Date.UTC(parseInt(old_launchingDate_arr[0],10) , parseInt(old_launchingDate_arr[1],10)-1 , parseInt(old_launchingDate_arr[2],10)+1 , parseInt(old_launchingDate_arr[3],10) , parseInt(old_launchingDate_arr[4],10) , parseInt(old_launchingDate_arr[5],10))/1000;	*/
									options.launchingDate=options.launchingDate+24*3600;
									//alert ("b: "+options.launchingDate);
									
									
									
									
									if (options.nowDate=='') {
										current_obj.totalRemainingSeconds=options.launchingDate-Date.UTC(current_obj.new_nowD.getFullYear(), current_obj.new_nowD.getMonth(), current_obj.new_nowD.getDate(),  current_obj.new_nowD.getHours(), current_obj.new_nowD.getMinutes(), current_obj.new_nowD.getSeconds())/1000;	
									} else {
										//options.nowDate
										current_obj.totalRemainingSeconds=options.launchingDate-(Date.UTC(parseInt(nowDate_arr[0],10) , parseInt(nowDate_arr[1],10)-1 , parseInt(nowDate_arr[2],10) , parseInt(nowDate_arr[3],10) , parseInt(nowDate_arr[4],10) , parseInt(nowDate_arr[5],10))/1000+theIntervalNowDate);								
									}
									/*current_obj.totalRemainingSeconds=24*3600;*/
									/*current_obj.totalRemainingSeconds=options.launchingDate-options.beginDate;*/
									
									//alert (current_obj.totalRemainingSeconds);
		
							}
							
							current_obj.entireWorkingDaysPeriod=Math.floor((options.launchingDate-options.beginDate)/current_obj.secondsInADay);
							calculateRemainingTime(current_obj,options);
					}
													
				}
			}
		}
    }	
	
	
	function centerNumbers(options,current_obj,daysDiv,hoursDiv,minutesDiv,secondsDiv) {
		//alert (daysDiv.height()+'   ----   '+current_obj.canvasHeight);
			$('.innerNumber',daysDiv).css({
				'display':'block',
				'left':parseInt((current_obj.canvasWidth-$('.innerNumber',daysDiv).width())/2,10)+'px',
				'top':parseInt((current_obj.canvasHeight-$('.innerNumber',daysDiv).height())/2-options.numberAdditionalTopPadding,10)+'px'
			});
			$('.innerNumber',hoursDiv).css({
				'display':'block',
				'left':parseInt((current_obj.canvasWidth-$('.innerNumber',hoursDiv).width())/2,10)+'px',
				'top':parseInt((current_obj.canvasHeight-$('.innerNumber',hoursDiv).height())/2-options.numberAdditionalTopPadding,10)+'px'
			});
			$('.innerNumber',minutesDiv).css({
				'display':'block',
				'left':parseInt((current_obj.canvasWidth-$('.innerNumber',minutesDiv).width())/2,10)+'px',
				'top':parseInt((current_obj.canvasHeight-$('.innerNumber',minutesDiv).height())/2-options.numberAdditionalTopPadding,10)+'px'
			});
			$('.innerNumber',secondsDiv).css({
				'display':'block',
				'left':parseInt((current_obj.canvasWidth-$('.innerNumber',secondsDiv).width())/2,10)+'px',
				'top':parseInt((current_obj.canvasHeight-$('.innerNumber',secondsDiv).height())/2-options.numberAdditionalTopPadding,10)+'px'
			});
			
			//alert (daysDiv.height()+'   ----   '+$('.innerText',daysDiv).height());
			//alert ($('.innerNumber',daysDiv).css('top'));
	}
	
	
	function doResize(current_obj,options,circularCountdown_container,logoDiv,daysDiv,hoursDiv,minutesDiv,secondsDiv,theCircles,socialIconsDiv,h2s,h3s,h4s) {
		  var ver_ie=getInternetExplorerVersion();
		  /*var bodyOverflow_initial=$('body').css('overflow');
		  $('body').css('overflow','hidden');*/
		  responsiveWidth=circularCountdown_container.parent().parent().width();
		  //responsiveHeight=circularCountdown_container.parent().parent().height();						
		  


		  if (options.origWidth!=responsiveWidth) {			  
			  if (responsiveWidth>options.origWidth)
				responsiveWidth=options.origWidth;
			  if (options.origWidth>responsiveWidth || options.prevOrigWidth!=responsiveWidth) {
			  	  options.prevOrigWidth=responsiveWidth;
				  //current_obj.pluginRatio=responsiveWidth*100/options.origWidth;
				  current_obj.pluginRatio=responsiveWidth/options.origWidth;
				  //alert (responsiveWidth);
				  //alert ("ratio:"+current_obj.pluginRatio);
				  //alert (responsiveWidth);
				  //set countDown size
				  current_obj.canvasWidth=parseInt(current_obj.canvasOrigWidth*current_obj.pluginRatio,10);
				  current_obj.canvasHeight=parseInt(current_obj.canvasOrigHeight*current_obj.pluginRatio,10);	
				  
				  /*** DAYS ***/
				  current_obj.canvasDays.width=current_obj.canvasWidth;
				  current_obj.canvasDays.height=current_obj.canvasHeight;				  

				  /*** HOURS ***/
				  current_obj.canvasHours.width=current_obj.canvasWidth;
				  current_obj.canvasHours.height=current_obj.canvasHeight;		
                
				  /*** MINUTES ***/
				  current_obj.canvasMinutes.width=current_obj.canvasWidth;
				  current_obj.canvasMinutes.height=current_obj.canvasHeight;
	  
				  /*** SECONDS ***/
				  current_obj.canvasSeconds.width=current_obj.canvasWidth;
				  current_obj.canvasSeconds.height=current_obj.canvasHeight;		
				  
				  
				  
				  //number position & styles
				  text_top_aux=0;
				  if (ver_ie!=-1 && ver_ie<9) {
					  text_top_aux=current_obj.canvasHeight;
				  }
				  //days
				  $('.innerNumber',daysDiv).css({
					  'font-size':parseInt(options.numberSize*current_obj.pluginRatio,10)+'px',
					  'line-height':parseInt(options.numberSize*current_obj.pluginRatio,10)+'px'
				  });
				  $('.innerText',daysDiv).css({
					  'top':text_top_aux+'px',
					  'font-size':parseInt(options.textSize*current_obj.pluginRatio,10)+'px',
					  'line-height':parseInt(options.textSize*current_obj.pluginRatio,10)+'px',
					  'margin-top':parseInt(options.textMarginTop*current_obj.pluginRatio,10)+'px',
					  'padding-top':parseInt(options.textPadding*current_obj.pluginRatio,10)+'px',
					  'padding-bottom':parseInt(options.textPadding*current_obj.pluginRatio,10)+'px'
				  });		
				  //hours
				  $('.innerNumber',hoursDiv).css({
					  'font-size':parseInt(options.numberSize*current_obj.pluginRatio,10)+'px',
					  'line-height':parseInt(options.numberSize*current_obj.pluginRatio,10)+'px'
				  });
				  $('.innerText',hoursDiv).css({
					  'top':text_top_aux+'px',
					  'font-size':parseInt(options.textSize*current_obj.pluginRatio,10)+'px',
					  'line-height':parseInt(options.textSize*current_obj.pluginRatio,10)+'px',
					  'margin-top':parseInt(options.textMarginTop*current_obj.pluginRatio,10)+'px',
					  'padding-top':parseInt(options.textPadding*current_obj.pluginRatio,10)+'px',
					  'padding-bottom':parseInt(options.textPadding*current_obj.pluginRatio,10)+'px'
				  });		
				  //minutes
				  $('.innerNumber',minutesDiv).css({
					  'font-size':parseInt(options.numberSize*current_obj.pluginRatio,10)+'px',
					  'line-height':parseInt(options.numberSize*current_obj.pluginRatio,10)+'px'
				  });
				  $('.innerText',minutesDiv).css({
					  'top':text_top_aux+'px',
					  'font-size':parseInt(options.textSize*current_obj.pluginRatio,10)+'px',
					  'line-height':parseInt(options.textSize*current_obj.pluginRatio,10)+'px',
					  'margin-top':parseInt(options.textMarginTop*current_obj.pluginRatio,10)+'px',
					  'padding-top':parseInt(options.textPadding*current_obj.pluginRatio,10)+'px',
					  'padding-bottom':parseInt(options.textPadding*current_obj.pluginRatio,10)+'px'
				  });		
				  //seconds
				  $('.innerNumber',secondsDiv).css({
					  'font-size':parseInt(options.numberSize*current_obj.pluginRatio,10)+'px',
					  'line-height':parseInt(options.numberSize*current_obj.pluginRatio,10)+'px'
				  });
				  $('.innerText',secondsDiv).css({
					  'top':text_top_aux+'px',
					  'font-size':parseInt(options.textSize*current_obj.pluginRatio,10)+'px',
					  'line-height':parseInt(options.textSize*current_obj.pluginRatio,10)+'px',
					  'margin-top':parseInt(options.textMarginTop*current_obj.pluginRatio,10)+'px',
					  'padding-top':parseInt(options.textPadding*current_obj.pluginRatio,10)+'px',
					  'padding-bottom':parseInt(options.textPadding*current_obj.pluginRatio,10)+'px'
				  });		
							
				  
				  //all the circles div
				  theCircles.css({
					  'width':parseInt(options.origWidth*current_obj.pluginRatio,10)+2+'px',
					  'margin-top':parseInt(options.allCirclesTopMargin*current_obj.pluginRatio,10)+'px',
					  'margin-bottom':parseInt(options.allCirclesBottomMargin*current_obj.pluginRatio,10)+'px'
				  });			
				  
				  
				  //Hs
				  h2s.css({
					  'font-family':options.pluginFontFamily+' !important',
					  'font-size':Math.max(10,parseInt(options.h2Size*current_obj.pluginRatio,10))+'px !important',
					  'line-height':Math.max(10,parseInt(options.h2Size*current_obj.pluginRatio,10))+'px !important',
					  'margin-top':Math.max(10,parseInt(options.h2TopMargin*current_obj.pluginRatio,10))+'px !important'
				  });	
				  h3s.css({
					  'font-family':options.pluginFontFamily+' !important',
					  'font-size':Math.max(8,parseInt(options.h3Size*current_obj.pluginRatio,10))+'px !important',
					  'line-height':Math.max(8,parseInt(options.h3Size*current_obj.pluginRatio,10))+'px !important',
					  'margin-top':parseInt(options.h3TopMargin*current_obj.pluginRatio,10)+'px !important'
				  });				
				  h4s.css({
					  'font-family':options.pluginFontFamily+' !important',
					  'font-size':Math.max(6,parseInt(options.h4Size*current_obj.pluginRatio,10))+'px !important',
					  'line-height':Math.max(6,parseInt(options.h4Size*current_obj.pluginRatio,10))+'px !important',
					  'margin-top':parseInt(options.h4TopMargin*current_obj.pluginRatio,10)+'px !important'
				  });	
				  
				  //logo
				  logoDiv.css({
					  'width':parseInt(options.origWidth*current_obj.pluginRatio,10)+'px'
				  });			
				  
				  //social Icons
				  socialIconsDiv.css({
					  'width':parseInt(options.origWidth*current_obj.pluginRatio,10)+'px'
				  });
		 	 }	
		  }
		  
		  

		  //$('body').css('overflow',bodyOverflow_initial);
	}		
	
	
	function getInternetExplorerVersion()
	// -1 - not IE
	// 7,8,9 etc
	{
	   var rv = -1; // Return value assumes failure.
	   if (navigator.appName == 'Microsoft Internet Explorer')
	   {
		  var ua = navigator.userAgent;
		  var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
		  if (re.exec(ua) != null)
			 rv = parseFloat( RegExp.$1 );
	   }
	   return parseInt(rv,10);
	}		
	
	function isImg(the_str) {
		var res=false;
		var last4=the_str.substr(the_str.length - 4).toLowerCase();
		if (last4=='.jpg' || last4=='.png' || last4=='.gif') {
			res=true;
		}
		return res;
	}	
			





	
	$.fn.circularCountdown = function(options) {
		
		var options = $.extend({},$.fn.circularCountdown.defaults, options);

		return this.each(function() {
			var circularCountdown_the = $(this);
			//the controllers
			var circularCountdown_wrap = $('<div></div>').addClass('circularCountdown').addClass(options.type);
			circularCountdown_the.wrap(circularCountdown_wrap);
			//the elements
			var circularCountdown_container = circularCountdown_the.parent('.circularCountdown');
			var secondsDiv = $('.secondsDiv', circularCountdown_container);
			var minutesDiv = $('.minutesDiv', circularCountdown_container);
			var hoursDiv = $('.hoursDiv', circularCountdown_container);
			var daysDiv = $('.daysDiv', circularCountdown_container);
			var theCircles = $('.theCircles', circularCountdown_container);
			var socialIcons = $('.socialIcons', circularCountdown_container);
			var socialIconsDiv = $('.socialIconsDiv', circularCountdown_container);
			var logoDiv = $('.logoDiv', circularCountdown_container);
			var h2s = $('h2', circularCountdown_container);
			var h3s = $('h3', circularCountdown_container);
			var h4s = $('h4', circularCountdown_container);
			var secondsInADay=86400;
			var secondsInAnHour=3600;
			var secondsInAMinute=60;
			var bg_aux='';
			var text_top_aux='';
			var borderTop_aux='';
			var borderRight_aux='';
			var borderBottom_aux='';
			var borderLeft_aux='';
			var ver_ie=getInternetExplorerVersion();
			var fi=0;
			
			circularCountdown_container.css({
				'font-family':options.pluginFontFamily+' !important'
			});
			
			var beginDate_arr=options.beginDate.split(',');
			var launchingDate_arr=options.launchingDate.split(',');
			options.beginDate=Date.UTC(parseInt(beginDate_arr[0],10) , parseInt(beginDate_arr[1],10)-1 , parseInt(beginDate_arr[2],10) , parseInt(beginDate_arr[3],10) , parseInt(beginDate_arr[4],10) , parseInt(beginDate_arr[5],10))/1000;
			options.launchingDate=Date.UTC(parseInt(launchingDate_arr[0],10) , parseInt(launchingDate_arr[1],10)-1 , parseInt(launchingDate_arr[2],10) , parseInt(launchingDate_arr[3],10) , parseInt(launchingDate_arr[4],10) , parseInt(launchingDate_arr[5],10))/1000;


			var current_obj = {
				nowD:new Date(),
				secondsInADay:86400,
				secondsInAnHour:3600,
				secondsInAMinute:60,
				entireWorkingDaysPeriod:0,
				totalRemainingSeconds:0,
				remainingDays:0,
				remainingHours:0,
				remainingMinutes:0,
				remainingSeconds:0,

				canvasSeconds:'',
				ctxSeconds:'',
				secondsNumberDiv:$('.innerNumber', secondsDiv),


				canvasMinutes:'',
				ctxMinutes:'',
				minutesNumberDiv:$('.innerNumber', minutesDiv),

				canvasHours:'',
				ctxHours:'',
				hoursNumberDiv:$('.innerNumber', hoursDiv),

				canvasDays:'',
				ctxDays:'',
				daysNumberDiv:$('.innerNumber', daysDiv),
				
				canvasWidth:0,
				canvasOrigWidth:0,
				canvasHeight:0,
				canvasOrigHeight:0,
				
				unitDivOrigWidth:0,
				unitDivOrigHeight:0,
				unitDivOrigWidthDays:0,
				unitDivOrigHeightDays:0,
				unitDivOrigWidthHours:0,
				unitDivOrigHeightHours:0,
				unitDivOrigWidthMinutes:0,
				unitDivOrigHeightMinutes:0,
				unitDivOrigWidthSeconds:0,
				unitDivOrigHeightSeconds:0,				
				
				pluginRatio:1,
				
				repetitionNo:0
			};	

			current_obj.entireWorkingDaysPeriod=Math.floor((options.launchingDate-options.beginDate)/current_obj.secondsInADay);
			nowDate_arr=options.nowDate.split(',');
			if (options.nowDate=='') {
				current_obj.totalRemainingSeconds=options.launchingDate-Date.UTC(current_obj.nowD.getFullYear(), current_obj.nowD.getMonth(), current_obj.nowD.getDate(),  current_obj.nowD.getHours(), current_obj.nowD.getMinutes(), current_obj.nowD.getSeconds())/1000;	
			} else {
				//options.nowDate
				current_obj.totalRemainingSeconds=options.launchingDate-Date.UTC(parseInt(nowDate_arr[0],10) , parseInt(nowDate_arr[1],10)-1 , parseInt(nowDate_arr[2],10) , parseInt(nowDate_arr[3],10) , parseInt(nowDate_arr[4],10) , parseInt(nowDate_arr[5],10))/1000;								
			}
			
			
			calculateRemainingTime(current_obj,options);
			
			current_obj.canvasWidth=2*options.circleRadius+options.circleLineWidth+options.behindCircleLineWidthExpand+2*options.circleLeftRightPadding;
			current_obj.canvasHeight=2*options.circleRadius+options.circleLineWidth+options.behindCircleLineWidthExpand+2*options.circleTopBottomPadding;
			current_obj.canvasOrigWidth=current_obj.canvasWidth;
			current_obj.canvasOrigHeight=current_obj.canvasHeight;
			
			if (ver_ie!=-1 && ver_ie<9) {
				//nothing	
			} else {

					/*** DAYS ***/
					current_obj.canvasDays = $('.canvasDays', circularCountdown_container)[0];
					current_obj.canvasDays.width=current_obj.canvasWidth;
					current_obj.canvasDays.height=current_obj.canvasHeight;			
					current_obj.ctxDays = current_obj.canvasDays.getContext('2d');
					the_arc('days',current_obj.ctxDays,current_obj.canvasDays,options.behindCircleAlphaDays,options.behindCircleColorDays,options.circleAlphaDays,options.circleColorDays,current_obj,options,daysDiv,hoursDiv,minutesDiv,secondsDiv,ver_ie,0);

					
					
					/*** HOURS ***/
					current_obj.canvasHours = $('.canvasHours', circularCountdown_container)[0];
					current_obj.canvasHours.width=current_obj.canvasWidth;
					current_obj.canvasHours.height=current_obj.canvasHeight;		
					current_obj.ctxHours = current_obj.canvasHours.getContext('2d');	
					the_arc('hours',current_obj.ctxHours,current_obj.canvasHours,options.behindCircleAlphaHours,options.behindCircleColorHours,options.circleAlphaHours,options.circleColorHours,current_obj,options,daysDiv,hoursDiv,minutesDiv,secondsDiv,ver_ie,0);		
		
		
					/*** MINUTES ***/
					current_obj.canvasMinutes = $('.canvasMinutes', circularCountdown_container)[0];
					current_obj.canvasMinutes.width=current_obj.canvasWidth;
					current_obj.canvasMinutes.height=current_obj.canvasHeight;
					current_obj.ctxMinutes = current_obj.canvasMinutes.getContext('2d');
					the_arc('minutes',current_obj.ctxMinutes,current_obj.canvasMinutes,options.behindCircleAlphaMinutes,options.behindCircleColorMinutes,options.circleAlphaMinutes,options.circleColorMinutes,current_obj,options,daysDiv,hoursDiv,minutesDiv,secondsDiv,ver_ie,0);
		
		
					/*** SECONDS ***/
					current_obj.canvasSeconds = $('.canvasSeconds', circularCountdown_container)[0];
					current_obj.canvasSeconds.width=current_obj.canvasWidth;
					current_obj.canvasSeconds.height=current_obj.canvasHeight;				
					current_obj.ctxSeconds = current_obj.canvasSeconds.getContext('2d');
					the_arc('seconds',current_obj.ctxSeconds,current_obj.canvasSeconds,options.behindCircleAlphaSeconds,options.behindCircleColorSeconds,options.circleAlphaSeconds,options.circleColorSeconds,current_obj,options,daysDiv,hoursDiv,minutesDiv,secondsDiv,ver_ie,0);
			}			


			//the magic
			current_obj.totalRemainingSeconds--;
			current_obj.intervalIDSeconds=setInterval(function(){
				current_obj.totalRemainingSeconds--;
				the_arc('seconds',current_obj.ctxSeconds,current_obj.canvasSeconds,options.behindCircleAlphaSeconds,options.behindCircleColorSeconds,options.circleAlphaSeconds,options.circleColorSeconds,current_obj,options,daysDiv,hoursDiv,minutesDiv,secondsDiv,ver_ie,1);
				the_arc('minutes',current_obj.ctxMinutes,current_obj.canvasMinutes,options.behindCircleAlphaMinutes,options.behindCircleColorMinutes,options.circleAlphaMinutes,options.circleColorMinutes,current_obj,options,daysDiv,hoursDiv,minutesDiv,secondsDiv,ver_ie,1);
				the_arc('hours',current_obj.ctxHours,current_obj.canvasHours,options.behindCircleAlphaHours,options.behindCircleColorHours,options.circleAlphaHours,options.circleColorHours,current_obj,options,daysDiv,hoursDiv,minutesDiv,secondsDiv,ver_ie,1);
				the_arc('days',current_obj.ctxDays,current_obj.canvasDays,options.behindCircleAlphaDays,options.behindCircleColorDays,options.circleAlphaDays,options.circleColorDays,current_obj,options,daysDiv,hoursDiv,minutesDiv,secondsDiv,ver_ie,1);
			}, 1000);	
			
			
			//circles padding, bg, border and width
			//days
			bg_aux=options.divBackgroundDays;
			if (isImg(options.divBackgroundDays)) {
				bg_aux="url("+options.divBackgroundDays+")";
			}
			borderTop_aux=0;
			if (options.borderTopColorDays!='')
				borderTop_aux="1px solid "+options.borderTopColorDays;
			borderRight_aux=0;
			if (options.borderRightColorDays!='')
				borderRight_aux="1px solid "+options.borderRightColorDays;
			borderBottom_aux=0;
			if (options.borderBottomColorDays!='')
				borderBottom_aux="1px solid "+options.borderBottomColorDays;
			borderLeft_aux=0;
			if (options.borderLeftColorDays!='')
				borderLeft_aux="1px solid "+options.borderLeftColorDays;				
			daysDiv.css({
				'border-top':borderTop_aux,
				'border-right':borderRight_aux,
				'border-bottom':borderBottom_aux,
				'border-left':borderLeft_aux,				
				'background':bg_aux
			});
			
			//hours
			bg_aux=options.divBackgroundHours;
			if (isImg(options.divBackgroundHours)) {
				bg_aux="url("+options.divBackgroundHours+")";
			}
			borderTop_aux=0;
			if (options.borderTopColorHours!='')
				borderTop_aux="1px solid "+options.borderTopColorHours;
			borderRight_aux=0;
			if (options.borderRightColorHours!='')
				borderRight_aux="1px solid "+options.borderRightColorHours;
			borderBottom_aux=0;
			if (options.borderBottomColorHours!='')
				borderBottom_aux="1px solid "+options.borderBottomColorHours;
			borderLeft_aux=0;
			if (options.borderLeftColorHours!='')
				borderLeft_aux="1px solid "+options.borderLeftColorHours;			
			hoursDiv.css({
				'border-top':borderTop_aux,
				'border-right':borderRight_aux,
				'border-bottom':borderBottom_aux,
				'border-left':borderLeft_aux,					
				'background':bg_aux
			});
			
			//minutes
			bg_aux=options.divBackgroundMinutes;
			if (isImg(options.divBackgroundMinutes)) {
				bg_aux="url("+options.divBackgroundMinutes+")";
			}
			borderTop_aux=0;
			if (options.borderTopColorMinutes!='')
				borderTop_aux="1px solid "+options.borderTopColorMinutes;
			borderRight_aux=0;
			if (options.borderRightColorMinutes!='')
				borderRight_aux="1px solid "+options.borderRightColorMinutes;
			borderBottom_aux=0;
			if (options.borderBottomColorMinutes!='')
				borderBottom_aux="1px solid "+options.borderBottomColorMinutes;
			borderLeft_aux=0;
			if (options.borderLeftColorMinutes!='')
				borderLeft_aux="1px solid "+options.borderLeftColorMinutes;			
			minutesDiv.css({
				'border-top':borderTop_aux,
				'border-right':borderRight_aux,
				'border-bottom':borderBottom_aux,
				'border-left':borderLeft_aux,				
				'background':bg_aux
			});
			
			//seconds
			bg_aux=options.divBackgroundSeconds;
			if (isImg(options.divBackgroundSeconds)) {
				bg_aux="url("+options.divBackgroundSeconds+")";
			}
			borderTop_aux=0;
			if (options.borderTopColorSeconds!='')
				borderTop_aux="1px solid "+options.borderTopColorSeconds;
			borderRight_aux=0;
			if (options.borderRightColorSeconds!='')
				borderRight_aux="1px solid "+options.borderRightColorSeconds;
			borderBottom_aux=0;
			if (options.borderBottomColorSeconds!='')
				borderBottom_aux="1px solid "+options.borderBottomColorSeconds;
			borderLeft_aux=0;
			if (options.borderLeftColorSeconds!='')
				borderLeft_aux="1px solid "+options.borderLeftColorSeconds;					
			secondsDiv.css({
				'border-top':borderTop_aux,
				'border-right':borderRight_aux,
				'border-bottom':borderBottom_aux,
				'border-left':borderLeft_aux,				
				'background':bg_aux
			});
			
			current_obj.unitDivOrigWidthDays=parseInt(2*options.circleRadius+options.circleLineWidth+options.behindCircleLineWidthExpand+2*options.circleLeftRightPadding,10);
			current_obj.unitDivOrigWidth=current_obj.unitDivOrigWidthDays;
			current_obj.unitDivOrigWidthHours=current_obj.unitDivOrigWidthDays;
			current_obj.unitDivOrigWidthMinutes=current_obj.unitDivOrigWidthDays;
			current_obj.unitDivOrigWidthSeconds=current_obj.unitDivOrigWidthDays;

			if (options.borderLeftColorDays!='')
				current_obj.unitDivOrigWidthDays--;
			if (options.borderRightColorDays!='')
				current_obj.unitDivOrigWidthDays--;

			if (options.borderLeftColorHours!='')
				current_obj.unitDivOrigWidthHours--;
			if (options.borderRightColorHours!='')
				current_obj.unitDivOrigWidthHours--;

			if (options.borderLeftColorMinutes!='')
				current_obj.unitDivOrigWidthMinutes--;
			if (options.borderRightColorMinutes!='')
				current_obj.unitDivOrigWidthMinutes--;

			if (options.borderLeftColorSeconds!='')
				current_obj.unitDivOrigWidthSeconds--;
			if (options.borderRightColorSeconds!='')
				current_obj.unitDivOrigWidthSeconds--;


			

			
			//number position & styles
			text_top_aux=0;
			if (ver_ie!=-1 && ver_ie<9) {
				text_top_aux=current_obj.canvasHeight;
			}
			//days
			$('.innerNumber',daysDiv).css({
				'color':options.numberColorDays,
				'font-size':options.numberSize+'px',
				'line-height':options.numberSize+'px'
			});
			bg_aux=options.textColorBackgroundDays;
			if (isImg(options.textColorBackgroundDays)) {
				bg_aux="url("+options.textColorBackgroundDays+")";
			}
			$('.innerText',daysDiv).css({
				'top':text_top_aux+'px',
				'color':options.textColorDays,
				'font-size':options.textSize+'px',
				'line-height':options.textSize+'px',
				'margin-top':options.textMarginTop+'px',
				'padding-top':options.textPadding+'px',
				'padding-bottom':options.textPadding+'px',
				'background':bg_aux
			});		
			//hours
			$('.innerNumber',hoursDiv).css({
				'color':options.numberColorHours,
				'font-size':options.numberSize+'px',
				'line-height':options.numberSize+'px'
			});
			bg_aux=options.textColorBackgroundHours;
			if (isImg(options.textColorBackgroundHours)) {
				bg_aux="url("+options.textColorBackgroundHours+")";
			}				
			$('.innerText',hoursDiv).css({
				'top':text_top_aux+'px',
				'color':options.textColorHours,
				'font-size':options.textSize+'px',
				'line-height':options.textSize+'px',
				'margin-top':options.textMarginTop+'px',
				'padding-top':options.textPadding+'px',
				'padding-bottom':options.textPadding+'px',
				'background':bg_aux
			});		
			//minutes
			$('.innerNumber',minutesDiv).css({
				'color':options.numberColorMinutes,
				'font-size':options.numberSize+'px',
				'line-height':options.numberSize+'px'
			});
			bg_aux=options.textColorBackgroundMinutes;
			if (isImg(options.textColorBackgroundMinutes)) {
				bg_aux="url("+options.textColorBackgroundMinutes+")";
			}
			$('.innerText',minutesDiv).css({
				'top':text_top_aux+'px',
				'color':options.textColorMinutes,
				'font-size':options.textSize+'px',
				'line-height':options.textSize+'px',
				'margin-top':options.textMarginTop+'px',				
				'padding-top':options.textPadding+'px',
				'padding-bottom':options.textPadding+'px',
				'background':bg_aux
			});		
			//seconds
			$('.innerNumber',secondsDiv).css({
				'color':options.numberColorSeconds,
				'font-size':options.numberSize+'px',
				'line-height':options.numberSize+'px'
			});
			bg_aux=options.textColorBackgroundSeconds;
			if (isImg(options.textColorBackgroundSeconds)) {
				bg_aux="url("+options.textColorBackgroundSeconds+")";
			}
			$('.innerText',secondsDiv).css({
				'top':text_top_aux+'px',
				'color':options.textColorSeconds,
				'font-size':options.textSize+'px',
				'line-height':options.textSize+'px',
				'margin-top':options.textMarginTop+'px',				
				'padding-top':options.textPadding+'px',
				'padding-bottom':options.textPadding+'px',
				'background':bg_aux
			});		
		

			var circularCountdownWidth=parseInt(secondsDiv.width()+minutesDiv.width()+hoursDiv.width()+daysDiv.width(),10);
			if (options.borderLeftColorDays!='')
				circularCountdownWidth++;
			if (options.borderRightColorDays!='')
				circularCountdownWidth++;
			if (options.borderLeftColorHours!='')
				circularCountdownWidth++;
			if (options.borderRightColorHours!='')
				circularCountdownWidth++;
			if (options.borderLeftColorMinutes!='')
				circularCountdownWidth++;
			if (options.borderRightColorMinutes!='')
				circularCountdownWidth++;	
			if (options.borderLeftColorSeconds!='')
				circularCountdownWidth++;
			if (options.borderRightColorSeconds!='')
				circularCountdownWidth++;
				
			options.origWidth=circularCountdownWidth;
			options.prevOrigWidth=circularCountdownWidth;										
			
			//all the circles div
			/*bg_aux=options.allCirclesBackground;
			if (isImg(options.allCirclesBackground)) {
				bg_aux="url("+options.allCirclesBackground+")";
			}*/
			theCircles.css({
				//'background':bg_aux,
				'margin-top':options.allCirclesTopMargin+'px',
				'margin-bottom':options.allCirclesBottomMargin+'px'
			});			
			
			//Hs
			h2s.css({
				'font-family':options.pluginFontFamily+' !important',
				'font-size':options.h2Size+'px !important',
				'line-height':options.h2Size+'px !important',
				'color':options.h2Color+' !important',
				'font-weight':options.h2Weight+' !important',
				'margin-top':options.h2TopMargin+'px !important'
			});	
			h3s.css({
				'font-family':options.pluginFontFamily+' !important',
				'font-size':options.h3Size+'px !important',
				'line-height':options.h3Size+'px !important',
				'color':options.h3Color+' !important',
				'font-weight':options.h3Weight+' !important',
				'margin-top':options.h3TopMargin+'px !important'
			});				
			h4s.css({
				'font-family':options.pluginFontFamily+' !important',
				'font-size':options.h4Size+'px !important',
				'line-height':options.h4Size+'px !important',
				'color':options.h4Color+' !important',
				'font-weight':options.h4Weight+' !important',
				'margin-top':options.h4TopMargin+'px !important'
			});	
			
			//logo
			logoDiv.css({
				'width':circularCountdownWidth+'px',
				'background':'url('+options.lineSeparatorImg+') bottom left repeat-x'
			});			
			
			//social Icons
			socialIconsDiv.css({
				'width':circularCountdownWidth+'px',
				'background':'url('+options.lineSeparatorImg+') top left repeat-x'
			});
			bg_aux=options.socialBgOFF;
			if (isImg(options.socialBgOFF)) {
				bg_aux="url("+options.socialBgOFF+") no-repeat";
			}					
			$('li',socialIcons).css({
				'background':bg_aux
			});
			
			$('li',socialIcons).mouseover(function() {
				bg_aux=options.socialBgON;
				if (isImg(options.socialBgON)) {
					bg_aux="url("+options.socialBgON+") no-repeat";
				}				
				$(this).css({
					'background':bg_aux
				});
			});
			$('li',socialIcons).mouseout(function() {
				bg_aux=options.socialBgOFF;
				if (isImg(options.socialBgOFF)) {
					bg_aux="url("+options.socialBgOFF+") no-repeat";
				}					
				$(this).css({
					'background':bg_aux
				});
			});
			
			
			current_obj.unitDivOrigHeightDays=parseInt(2*options.circleRadius+options.circleLineWidth+options.behindCircleLineWidthExpand+2*options.circleTopBottomPadding+$('.innerText',daysDiv).height()+2*options.textPadding+options.textMarginTop,10);
			current_obj.unitDivOrigHeight=current_obj.unitDivOrigHeightDays;
			current_obj.unitDivOrigHeightHours=current_obj.unitDivOrigHeightDays;
			current_obj.unitDivOrigHeightMinutes=current_obj.unitDivOrigHeightDays;
			current_obj.unitDivOrigHeightSeconds=current_obj.unitDivOrigHeightDays;
			
			if (options.borderTopColorDays!='')
				current_obj.unitDivOrigHeightDays--;
			if (options.borderBottomColorDays!='')
				current_obj.unitDivOrigHeightDays--;			

			if (options.borderTopColorHours!='')
				current_obj.unitDivOrigHeightHours--;
			if (options.borderBottomColorHours!='')
				current_obj.unitDivOrigHeightHours--;				

			if (options.borderTopColorMinutes!='')
				current_obj.unitDivOrigHeightMinutes--;
			if (options.borderBottomColorMinutes!='')
				current_obj.unitDivOrigHeightMinutes--;				

			if (options.borderTopColorSeconds!='')
				current_obj.unitDivOrigHeightSeconds--;
			if (options.borderBottomColorSeconds!='')
				current_obj.unitDivOrigHeightSeconds--;				
		
			
			//centerNumbers(options,current_obj,daysDiv,hoursDiv,minutesDiv,secondsDiv);
			setTimeout(function(){centerNumbers(options,current_obj,daysDiv,hoursDiv,minutesDiv,secondsDiv) }, 200);
			
			if (options.responsive) {
				doResize(current_obj,options,circularCountdown_container,logoDiv,daysDiv,hoursDiv,minutesDiv,secondsDiv,theCircles,socialIconsDiv,h2s,h3s,h4s);	
			}
			
			
			var TO = false;
			$(window).resize(function() {
				var ver_ie=getInternetExplorerVersion();
				doResizeNow=true;
				/*if (navigator.userAgent.indexOf('Android') != -1) {
					if (options.windowOrientationScreenSize0==0 && window.orientation==0)
						options.windowOrientationScreenSize0=$(window).width();
						
					if (options.windowOrientationScreenSize90==0 && window.orientation==90)
						options.windowOrientationScreenSize90=$(window).height();	
						
					if (options.windowOrientationScreenSize_90==0 && window.orientation==-90)
						options.windowOrientationScreenSize_90=$(window).height();						
					
					if (options.windowOrientationScreenSize0 && window.orientation==0 && $(window).width()>options.windowOrientationScreenSize0)	
						doResizeNow=false;

					if (options.windowOrientationScreenSize90 && window.orientation==90 && $(window).height()>options.windowOrientationScreenSize90)	
						doResizeNow=false;
						
					if (options.windowOrientationScreenSize_90 && window.orientation==-90 && $(window).height()>options.windowOrientationScreenSize_90)	
						doResizeNow=false;		
						
					if (current_obj.windowWidth==0) {
						doResizeNow=false;
						current_obj.windowWidth=$(window).width();
					}

				}*/
				
				if (ver_ie!=-1 && ver_ie==9 && current_obj.windowWidth==0)
					doResizeNow=false;
				
				
				if (current_obj.windowWidth==$(window).width()) {
					doResizeNow=false;
					if (options.windowCurOrientation!=window.orientation && navigator.userAgent.indexOf('Android') != -1) {
						options.windowCurOrientation=window.orientation;
						doResizeNow=true;
					}
				} else {
					/*if (current_obj.windowWidth===0 && (val.indexOf("ipad") != -1 || val.indexOf("iphone") != -1 || val.indexOf("ipod") != -1 || val.indexOf("webos") != -1))
						doResizeNow=false;*/
					current_obj.windowWidth=$(window).width();
				}

				if (options.responsive && doResizeNow) {
					 if(TO !== false)
						clearTimeout(TO);
					 
					
					 TO = setTimeout(function(){doResize(current_obj,options,circularCountdown_container,logoDiv,daysDiv,hoursDiv,minutesDiv,secondsDiv,theCircles,socialIconsDiv,h2s,h3s,h4s) }, 300); //200 is time in miliseconds
				}
			});			
			
			
		
			/*if ( $.isFunction( options.complete ) ) {
				options.complete.call( this );
			}*/
			
			
		});
		
		
		
		

		
			/*$.circularCountdown.callBack = function(event) {
				current_obj.isPrettyPhoto=false;
				multimedia_classic_carousel_container.mouseleave();
			}	*/	
	};

	
	//
	// plugin type
	//
	$.fn.circularCountdown.defaults = {
			type: 'version1', //unused
			
			beginDate:'2014,2,30,22,30,10',
			launchingDate:'2018,8,30,14,12,10',
			nowDate:'',
			/*beginDate:Date.UTC(2012,2,30,22,30,10)/1000,
			launchingDate:Date.UTC(2013,8,30,14,12,10)/1000,*/
			
			pluginFontFamily:"'PT Serif', serif",
			circleRadius:85,
			circleLineWidth:20,
			behindCircleLineWidthExpand:6,
			circleTopBottomPadding:20,
			circleLeftRightPadding:30,
			numberSize: 60,
			numberAdditionalTopPadding:2,
			textSize: 24,
			textMarginTop:18,
			textPadding:15,
			//allCirclesBackground: "",
			lineSeparatorImg:'circular_countdown_images/line.png',
			
			allCirclesTopMargin:0,
			allCirclesBottomMargin:80,			

			
			divBackgroundDays: "",
			borderTopColorDays:"",
			borderRightColorDays:"",
			borderBottomColorDays:"",
			borderLeftColorDays:"",
			circleColorDays:"#dd1e2f",
			circleAlphaDays:100,
			behindCircleColorDays:"#000000",
			behindCircleAlphaDays:30,
			numberColorDays:"#FFFFFF",		
			textColorDays:"#6f6f6f",
			textColorBackgroundDays:"",
			
			divBackgroundHours: "",
			borderTopColorHours:"",
			borderRightColorHours:"",
			borderBottomColorHours:"",
			borderLeftColorHours:"",			
			circleColorHours:"#ebb035",
			circleAlphaHours:100,
			behindCircleColorHours:"#000000",
			behindCircleAlphaHours:30,		
			numberColorHours:"#FFFFFF",
			textColorHours:"#6f6f6f",
			textColorBackgroundHours:"",		
			
			divBackgroundMinutes: "",
			borderTopColorMinutes:"",
			borderRightColorMinutes:"",
			borderBottomColorMinutes:"",
			borderLeftColorMinutes:"",			
			circleColorMinutes:"#06a2cb",
			circleAlphaMinutes:100,
			behindCircleColorMinutes:"#000000",
			behindCircleAlphaMinutes:30,
			numberColorMinutes:"#FFFFFF",
			textColorMinutes:"#6f6f6f",
			textColorBackgroundMinutes:"",	

			divBackgroundSeconds: "",
			borderTopColorSeconds:"",
			borderRightColorSeconds:"",
			borderBottomColorSeconds:"",
			borderLeftColorSeconds:"",			
			circleColorSeconds:"#218559",
			circleAlphaSeconds:100,
			behindCircleColorSeconds: "#000000",
			behindCircleAlphaSeconds:30,
			numberColorSeconds:"#FFFFFF",
			textColorSeconds:"#6f6f6f",
			textColorBackgroundSeconds:"",
			
			socialBgOFF:'circular_countdown_images/social_icons/socialCircleOFF.png',
			socialBgON:'circular_countdown_images/social_icons/socialCircleON.png',
			
			h2Size:36,
			h2Color:'#FFFFFF',
			h2Weight:'bold', //normal/bold
			h2TopMargin:60,
			
			h3Size:24,
			h3Color:'#6f6f6f',
			h3Weight:'normal', //normal/bold
			h3TopMargin:0,
			
			h4Size:14,
			h4Color:'#6f6f6f',
			h4Weight:'normal', //normal/bold
			h4TopMargin:15,			
						
			complete:null, //callback function
			autoReset24h:false,
			
			responsive:false,

			
			origWidth:0,
			//origHeight:0,
			prevOrigWidth:0,
			thumbsWrapperMarginBottom:0,
			windowOrientationScreenSize0:0,
			windowOrientationScreenSize90:0,
			windowOrientationScreenSize_90:0,
			windowCurOrientation:0					
								
			
	};

})(jQuery);

var DateFormat = {};

(function($) {
  var daysInWeek          = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var shortDaysInWeek     = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var shortMonthsInYear   = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                              'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var longMonthsInYear    = ['January', 'February', 'March', 'April', 'May', 'June',
                              'July', 'August', 'September', 'October', 'November', 'December'];
  var shortMonthsToNumber = { 'Jan': '01', 'Feb': '02', 'Mar': '03', 'Apr': '04', 'May': '05', 'Jun': '06',
                              'Jul': '07', 'Aug': '08', 'Sep': '09', 'Oct': '10', 'Nov': '11', 'Dec': '12' };

  var YYYYMMDD_MATCHER = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.?\d{0,3}[Z\-+]?(\d{2}:?\d{2})?/;

  $.format = (function() {
    function numberToLongDay(value) {
      // 0 to Sunday
      // 1 to Monday
      return daysInWeek[parseInt(value, 10)] || value;
    }

    function numberToShortDay(value) {
      // 0 to Sun
      // 1 to Mon
      return shortDaysInWeek[parseInt(value, 10)] || value;
    }

    function numberToShortMonth(value) {
      // 1 to Jan
      // 2 to Feb
      var monthArrayIndex = parseInt(value, 10) - 1;
      return shortMonthsInYear[monthArrayIndex] || value;
    }

    function numberToLongMonth(value) {
      // 1 to January
      // 2 to February
      var monthArrayIndex = parseInt(value, 10) - 1;
      return longMonthsInYear[monthArrayIndex] || value;
    }

    function shortMonthToNumber(value) {
      // Jan to 01
      // Feb to 02
      return shortMonthsToNumber[value] || value;
    }

    function parseTime(value) {
      // 10:54:50.546
      // => hour: 10, minute: 54, second: 50, millis: 546
      // 10:54:50
      // => hour: 10, minute: 54, second: 50, millis: ''
      var time = value,
          hour,
          minute,
          second,
          millis = '',
          delimited,
          timeArray;

      if(time.indexOf('.') !== -1) {
        delimited = time.split('.');
        // split time and milliseconds
        time   = delimited[0];
        millis = delimited[delimited.length - 1];
      }

      timeArray = time.split(':');

      if(timeArray.length === 3) {
        hour   = timeArray[0];
        minute = timeArray[1];
        // '20 GMT-0200 (BRST)'.replace(/\s.+/, '').replace(/[a-z]/gi, '');
        // => 20
        // '20Z'.replace(/\s.+/, '').replace(/[a-z]/gi, '');
        // => 20
        second = timeArray[2].replace(/\s.+/, '').replace(/[a-z]/gi, '');
        // '01:10:20 GMT-0200 (BRST)'.replace(/\s.+/, '').replace(/[a-z]/gi, '');
        // => 01:10:20
        // '01:10:20Z'.replace(/\s.+/, '').replace(/[a-z]/gi, '');
        // => 01:10:20
        time = time.replace(/\s.+/, '').replace(/[a-z]/gi, '');
        return {
          time:    time,
          hour:    hour,
          minute:  minute,
          second:  second,
          millis:  millis
        };
      }

      return { time : '', hour : '', minute : '', second : '', millis : '' };
    }


    function padding(value, length) {
      var paddingCount = length - String(value).length;
      for(var i = 0; i < paddingCount; i++) {
        value = '0' + value;
      }
      return value;
    }

    return {

      parseDate: function(value) {
        var values,
            subValues;

        var parsedDate = {
          date:       null,
          year:       null,
          month:      null,
          dayOfMonth: null,
          dayOfWeek:  null,
          time:       null
        };

        if(typeof value == 'number') {
          return this.parseDate(new Date(value));
        } else if(typeof value.getFullYear == 'function') {
          parsedDate.year       = String(value.getFullYear());
          // d = new Date(1900, 1, 1) // 1 for Feb instead of Jan.
          // => Thu Feb 01 1900 00:00:00
          parsedDate.month      = String(value.getMonth() + 1);
          parsedDate.dayOfMonth = String(value.getDate());
          parsedDate.time       = parseTime(value.toTimeString() + '.' + value.getMilliseconds());
        } else if(value.search(YYYYMMDD_MATCHER) != -1) {
          /* 2009-04-19T16:11:05+02:00 || 2009-04-19T16:11:05Z */
          values = value.split(/[T\+-]/);
          parsedDate.year       = values[0];
          parsedDate.month      = values[1];
          parsedDate.dayOfMonth = values[2];
          parsedDate.time       = parseTime(values[3].split('.')[0]);
        } else {
          values = value.split(' ');
          if(values.length === 6 && isNaN(values[5])) {
            // values[5] == year
            /*
             * This change is necessary to make `Mon Apr 28 2014 05:30:00 GMT-0300` work
             * like `case 7`
             * otherwise it will be considered like `Wed Jan 13 10:43:41 CET 2010
             * Fixes: https://github.com/phstc/jquery-dateFormat/issues/64
             */
            values[values.length] = '()';
          }
          switch (values.length) {
            case 6:
              /* Wed Jan 13 10:43:41 CET 2010 */
              parsedDate.year       = values[5];
              parsedDate.month      = shortMonthToNumber(values[1]);
              parsedDate.dayOfMonth = values[2];
              parsedDate.time       = parseTime(values[3]);
              break;
            case 2:
              /* 2009-12-18 10:54:50.546 */
              subValues = values[0].split('-');
              parsedDate.year       = subValues[0];
              parsedDate.month      = subValues[1];
              parsedDate.dayOfMonth = subValues[2];
              parsedDate.time       = parseTime(values[1]);
              break;
            case 7:
              /* Tue Mar 01 2011 12:01:42 GMT-0800 (PST) */
            case 9:
              /* added by Larry, for Fri Apr 08 2011 00:00:00 GMT+0800 (China Standard Time) */
            case 10:
              /* added by Larry, for Fri Apr 08 2011 00:00:00 GMT+0200 (W. Europe Daylight Time) */
              parsedDate.year       = values[3];
              /* edited by Andrey, for Mon 18 Apr 2016 -//-: '[Day] [Month]' format (russian) */
              var parsedVal1 = parseInt(values[1]);
              var parsedVal2 = parseInt(values[2]);
              if (parsedVal1 && !parsedVal2) {
                  parsedDate.month  = shortMonthToNumber(values[2]);
                  parsedDate.dayOfMonth = values[1];
              } else {
                  parsedDate.month = shortMonthToNumber(values[1]);
                  parsedDate.dayOfMonth = values[2];
              }
              parsedDate.time = parseTime(values[4]);
              break;
            case 1:
              /* added by Jonny, for 2012-02-07CET00:00:00 (Doctrine Entity -> Json Serializer) */
              subValues = values[0].split('');
              parsedDate.year       = subValues[0] + subValues[1] + subValues[2] + subValues[3];
              parsedDate.month      = subValues[5] + subValues[6];
              parsedDate.dayOfMonth = subValues[8] + subValues[9];
              parsedDate.time       = parseTime(subValues[13] + subValues[14] + subValues[15] + subValues[16] + subValues[17] + subValues[18] + subValues[19] + subValues[20]);
              break;
            default:
              return null;
          }
        }

        if(parsedDate.time) {
          parsedDate.date = new Date(parsedDate.year, parsedDate.month - 1, parsedDate.dayOfMonth, parsedDate.time.hour, parsedDate.time.minute, parsedDate.time.second, parsedDate.time.millis);
        } else {
          parsedDate.date = new Date(parsedDate.year, parsedDate.month - 1, parsedDate.dayOfMonth);
        }

        parsedDate.dayOfWeek = String(parsedDate.date.getDay());

        return parsedDate;
      },

      date : function(value, format) {
        try {
          var parsedDate = this.parseDate(value);

          if(parsedDate === null) {
            return value;
          }

          var year       = parsedDate.year,
              month      = parsedDate.month,
              dayOfMonth = parsedDate.dayOfMonth,
              dayOfWeek  = parsedDate.dayOfWeek,
              time       = parsedDate.time;
          var hour;

          var pattern      = '',
              retValue     = '',
              unparsedRest = '',
              inQuote      = false;

          /* Issue 1 - variable scope issue in format.date (Thanks jakemonO) */
          for(var i = 0; i < format.length; i++) {
            var currentPattern = format.charAt(i);
            // Look-Ahead Right (LALR)
            var nextRight      = format.charAt(i + 1);

            if (inQuote) {
              if (currentPattern == "'") {
                retValue += (pattern === '') ? "'" : pattern;
                pattern = '';
                inQuote = false;
              } else {
                pattern += currentPattern;
              }
              continue;
            }
            pattern += currentPattern;
            unparsedRest = '';
            switch (pattern) {
              case 'ddd':
                retValue += numberToLongDay(dayOfWeek);
                pattern = '';
                break;
              case 'dd':
                if(nextRight === 'd') {
                  break;
                }
                retValue += padding(dayOfMonth, 2);
                pattern = '';
                break;
              case 'd':
                if(nextRight === 'd') {
                  break;
                }
                retValue += parseInt(dayOfMonth, 10);
                pattern = '';
                break;
              case 'D':
                if(dayOfMonth == 1 || dayOfMonth == 21 || dayOfMonth == 31) {
                  dayOfMonth = parseInt(dayOfMonth, 10) + 'st';
                } else if(dayOfMonth == 2 || dayOfMonth == 22) {
                  dayOfMonth = parseInt(dayOfMonth, 10) + 'nd';
                } else if(dayOfMonth == 3 || dayOfMonth == 23) {
                  dayOfMonth = parseInt(dayOfMonth, 10) + 'rd';
                } else {
                  dayOfMonth = parseInt(dayOfMonth, 10) + 'th';
                }
                retValue += dayOfMonth;
                pattern = '';
                break;
              case 'MMMM':
                retValue += numberToLongMonth(month);
                pattern = '';
                break;
              case 'MMM':
                if(nextRight === 'M') {
                  break;
                }
                retValue += numberToShortMonth(month);
                pattern = '';
                break;
              case 'MM':
                if(nextRight === 'M') {
                  break;
                }
                retValue += padding(month, 2);
                pattern = '';
                break;
              case 'M':
                if(nextRight === 'M') {
                  break;
                }
                retValue += parseInt(month, 10);
                pattern = '';
                break;
              case 'y':
              case 'yyy':
                if(nextRight === 'y') {
                  break;
                }
                retValue += pattern;
                pattern = '';
                break;
              case 'yy':
                if(nextRight === 'y') {
                  break;
                }
                retValue += String(year).slice(-2);
                pattern = '';
                break;
              case 'yyyy':
                retValue += year;
                pattern = '';
                break;
              case 'HH':
                retValue += padding(time.hour, 2);
                pattern = '';
                break;
              case 'H':
                if(nextRight === 'H') {
                  break;
                }
                retValue += parseInt(time.hour, 10);
                pattern = '';
                break;
              case 'hh':
                /* time.hour is '00' as string == is used instead of === */
                hour = (parseInt(time.hour, 10) === 0 ? 12 : time.hour < 13 ? time.hour
                    : time.hour - 12);
                retValue += padding(hour, 2);
                pattern = '';
                break;
              case 'h':
                if(nextRight === 'h') {
                  break;
                }
                hour = (parseInt(time.hour, 10) === 0 ? 12 : time.hour < 13 ? time.hour
                    : time.hour - 12);
                retValue += parseInt(hour, 10);
                // Fixing issue https://github.com/phstc/jquery-dateFormat/issues/21
                // retValue = parseInt(retValue, 10);
                pattern = '';
                break;
              case 'mm':
                retValue += padding(time.minute, 2);
                pattern = '';
                break;
              case 'm':
                if(nextRight === 'm') {
                  break;
                }
                retValue += time.minute;
                pattern = '';
                break;
              case 'ss':
                /* ensure only seconds are added to the return string */
                retValue += padding(time.second.substring(0, 2), 2);
                pattern = '';
                break;
              case 's':
                if(nextRight === 's') {
                  break;
                }
                retValue += time.second;
                pattern = '';
                break;
              case 'S':
              case 'SS':
                if(nextRight === 'S') {
                  break;
                }
                retValue += pattern;
                pattern = '';
                break;
              case 'SSS':
                retValue +=  padding(time.millis.substring(0, 3), 3);
                pattern = '';
                break;
              case 'a':
                retValue += time.hour >= 12 ? 'PM' : 'AM';
                pattern = '';
                break;
              case 'p':
                retValue += time.hour >= 12 ? 'p.m.' : 'a.m.';
                pattern = '';
                break;
              case 'E':
                retValue += numberToShortDay(dayOfWeek);
                pattern = '';
                break;
              case "'":
                pattern = '';
                inQuote = true;
                break;
              default:
                retValue += currentPattern;
                pattern = '';
                break;
            }
          }
          retValue += unparsedRest;
          return retValue;
        } catch (e) {
          if(console && console.log) {
            console.log(e);
          }
          return value;
        }
      },
      
      prettyDate : function(time) {
        var date;
        var diff;
        var abs_diff;
        var day_diff;
        var abs_day_diff;
        var tense;

        if(typeof time === 'string' || typeof time === 'number') {
          date = new Date(time);
        }

        if(typeof time === 'object') {
          date = new Date(time.toString());
        }

        diff = (((new Date()).getTime() - date.getTime()) / 1000);
  
        abs_diff = Math.abs(diff);
        abs_day_diff = Math.floor(abs_diff / 86400);

        if(isNaN(abs_day_diff)) {
          return;
        }

        tense = diff < 0 ? 'from now' : 'ago';
  
        if(abs_diff < 60) {
          if(diff >= 0)
            return 'just now';
          else
            return 'in a moment';
        } else if(abs_diff < 120) {
          return '1 minute ' + tense;
        } else if(abs_diff < 3600) {
          return Math.floor(abs_diff / 60) + ' minutes ' + tense;
        } else if(abs_diff < 7200) {
          return '1 hour ' + tense;
        } else if(abs_diff < 86400) {
          return Math.floor(abs_diff / 3600) + ' hours ' + tense;
        } else if(abs_day_diff === 1) {
          if(diff >= 0)
            return 'Yesterday';
          else
            return 'Tomorrow';
        } else if(abs_day_diff < 7) {
          return abs_day_diff + ' days ' + tense;
        } else if(abs_day_diff === 7) {
          return '1 week ' + tense;
        } else if(abs_day_diff < 31) {
          return Math.ceil(abs_day_diff / 7) + ' weeks ' + tense;
        } else {
          return 'more than 5 weeks ' + tense;
        }
      },
      toBrowserTimeZone : function(value, format) {
        return this.date(new Date(value), format || 'MM/dd/yyyy HH:mm:ss');
      }
    };
  }());
}(DateFormat)); 
  
(function($) {
  $.format = DateFormat.format;
}(jQuery));